import React from 'react';
import PropTypes from 'prop-types';
import Typography from "../../../../components/Typography";
import {MuiTextField} from "../../../../components/MuiComponents/FormInputs";
import Button from "../../../../components/Button";
import {useForm} from "react-hook-form";
import {otp, required_message} from "../../../../utils/validations";
import {useDispatch, useSelector} from "react-redux";
import {useMutation} from "react-query";
import {validateOtp, verifyResetOtp} from "../../../../api/mutations/auth";
import {useLocation} from "react-router-dom";
import {clearFormError, setFormError, setTokenFromOtp} from "../../../../redux/reducers/auth";
import MainLoader from "../../../../components/Loader/MainLoader";
import { useFetchUserDataFromToken } from '../../../../hooks/auth';

const OtpForm = ({submit}) => {
    const {register, handleSubmit, formState: {errors, isValid}} = useForm({mode:'onChange'})
    const {forgotPasswordModal, formErrors, forgotPasswordData} = useSelector(state => state.auth)
    // validate otp mutation
    const mutation = useMutation(validateOtp)
    const mutationVerifyResetOtp = useMutation(verifyResetOtp)

    const {search} = useLocation()
    const params = new URLSearchParams(search)
    const token = params.get("token")

    const { data: userData, isLoading: userDataIsLoading } = useFetchUserDataFromToken({token})
    
    const dispatch = useDispatch()
    const onSubmit = async (data) => {
        try {
            if (forgotPasswordModal)
                await verifyResetOtpFn(data)
            else
                await confirmInviteOtp(data)
            submit("otp")
            dispatch((clearFormError("otp_form")))
        } catch (e) {
            dispatch((setFormError({
                otp_form: e?.response?.data?.message || "error"
            })))
        }
    }
    const confirmInviteOtp = async (data) => {
        data.token = token;
        let res = await mutation.mutateAsync(data)
        dispatch(setTokenFromOtp(res.token))
    }
    const verifyResetOtpFn = async (data) => {
        data.email = forgotPasswordData.email
        let res = await mutationVerifyResetOtp.mutateAsync(data)
        dispatch(setTokenFromOtp(res.token))
    }
    let disabled = Object.keys(errors).length > 0 || !isValid || formErrors?.otp_form?.length > 0
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {(mutation.isLoading || mutationVerifyResetOtp.isLoading || userDataIsLoading) && <MainLoader/>}
            <Typography variant={"h4"} className={"text-primary-800 pb-2.5"}>{forgotPasswordModal ?
                "Verify Code" : `Hello ${userData?.name},`}</Typography>
            <Typography variant={"body1"} className={"px-2"}>{forgotPasswordModal ?
                `Please verify the Verification Code sent to your email address ${forgotPasswordData.email} & Enter it below.` :
                `As the first step, let's verify your Account. A Verification Code has been sent to your email address ${userData?.email} Enter it below.`}</Typography>
            <MuiTextField label={"Your Verification Code"}
                          InputProps={{...register("otp", {required: required_message, ...otp})}}
                          error={Boolean(errors?.otp)}
                          helperText={errors?.otp?.message}
                          onKeyUp={() => {
                              dispatch((setFormError({
                                  otp_form:null
                              })))
                          }}
                          type={"password"}
            />
            <Typography className={"text-functional-red"}>{formErrors?.otp_form}</Typography>
            <Button disabled={disabled} className={"mt-2"}>Confirm</Button>
        </form>
    );
};

OtpForm.propTypes = {
    submit: PropTypes.func.isRequired
};

export default OtpForm;
